export * from './accountController.service';
import { AccountControllerService } from './accountController.service';
export * from './authController.service';
import { AuthControllerService } from './authController.service';
export * from './clientAccountController.service';
import { ClientAccountControllerService } from './clientAccountController.service';
export * from './managementAccountController.service';
import { ManagementAccountControllerService } from './managementAccountController.service';
export * from './userLoginController.service';
import { UserLoginControllerService } from './userLoginController.service';
export const APIS = [AccountControllerService, AuthControllerService, ClientAccountControllerService, ManagementAccountControllerService, UserLoginControllerService];
